import { render } from "./CountryModal.vue?vue&type=template&id=10db0e84"
import script from "./CountryModal.vue?vue&type=script&lang=js"
export * from "./CountryModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__